// aiPromptReducer.ts
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    loading: false,
    aiPrompts: {
        count: 0,
        rows: [],
        offset: 0,
        limit: 10,
        search: '',
    },
    aiPromptToDelete: null,
};

const aiPromptSlice = createSlice({
    name: 'aiPrompt',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setAIPrompts: (state, action) => {
            if (action.payload.data || (action.payload.aiprompt_aggregate && action.payload.aiprompt)) {
                // This handles the response from the API
                // If it has data property or directly contains aggregate/rows
                const data = action.payload.data ? action.payload.data : action.payload;
                
                state.aiPrompts = {
                    ...state.aiPrompts,
                    count: data.aiprompt_aggregate.aggregate.totalCount,
                    rows: data.aiprompt,
                };
            } else {
                // This handles direct updates to search, offset, or limit
                state.aiPrompts = {
                    ...state.aiPrompts,
                    ...action.payload,
                };
            }
        },
        deleteAIPrompt: (state, action) => {
            state.aiPromptToDelete = action.payload;
        },
    },
});

export const { setLoading, setAIPrompts, deleteAIPrompt } = aiPromptSlice.actions;

export default aiPromptSlice.reducer;
